module.exports = __webpack_public_path__ + "static/media/main idea.d786313e.mp3";